import { EnvConfig } from '@shared/definitions';

export const environment: EnvConfig = {
  featureFlags: {
    reservations: true,
    subscriptions: true,
  },
  production: false,
  staging: true,
  development: false,
  api: 'https://pauly-acceptance.azurewebsites.net',
  facebookAppId: '',
  instrumentationKey: '',
  recaptchaSiteKey: '6LfVh_gtAAAAAHpRG5Ek10e0fB-AF7DqxsBFkiVQ',
  clarityId: '',
};
